import { Routes } from '@angular/router';
import { NotEquipmentGuard } from './shared/guards/NotEquipmentGuard';

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('./main/main.routes').then((m) => m.MAIN_ROUTES),
    canActivate: [NotEquipmentGuard],
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.routes').then((m) => m.ACCOUNT_ROUTES),
    canActivate: [NotEquipmentGuard],
  },
  {
    path: 'medinbox',
    loadChildren: () => import('./medinbox/medinbox.routes').then((m) => m.MEDINBOX_ROUTES),
  },
  { path: 'live', loadChildren: () => import('./live/live.routes').then((m) => m.LIVE_ROUTES) },

  { path: 'legal', loadComponent: () => import('./shared/components/legal/legal.component').then((m) => m.LegalComponent) },
  { path: '**', loadComponent: () => import('./shared/components/not-found/not-found.component').then((m) => m.NotFoundComponent) },
];
